import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"

const TD = TypeDescriptors

const listDescriptor = {
    length: TD.inlet(TD.Primitive<number>()),
    __output_value: TD.outlet(TD.Array(TD.Identity<any>())),
}

export class List<T> implements NodeClassImpl<typeof listDescriptor, typeof List> {
    static descriptor = listDescriptor
    static uniqueName = "List"
    length!: Inlet<number>;
    [index: number]: Inlet<T>
    __output_value!: Outlet<T[]>

    run() {
        if (this.length === NotReady) {
            this.__output_value.emitIfChanged(NotReady)
            return
        }
        const list: T[] = []
        for (let n = 0; n < this.length; n++) {
            const elem = this[n]
            if (elem === NotReady) {
                this.__output_value.emitIfChanged(NotReady)
                return
            }
            list.push(elem)
        }
        this.__output_value.emitIfChanged(list)
    }
}
